import { AftersalesOrderItem } from '@1po/1po-bff-fe-spec/generated/aftersales_order/model/AftersalesOrder';
import {
  ASC,
  ASC_EXADIS,
  ClaimFormGroupType,
  ClaimFormType,
  DIRECT_DELIVERY,
  FULL_OTC,
} from 'domains/order/Order.types';

export const getOrderMarkMaxLength = (userCountry: string | undefined): number => {
  switch (userCountry) {
    case 'ES':
      return 17;
    case 'IT':
      return 7;
    default:
      return 40;
  }
};

export const getFormGroupType = (formType: ClaimFormType): ClaimFormGroupType => {
  switch (formType) {
    case DIRECT_DELIVERY:
      return DIRECT_DELIVERY;
    case ASC:
    case ASC_EXADIS:
    case FULL_OTC:
      return FULL_OTC;
    default:
      return undefined;
  }
};

export const EXADIS_SUPPLIER_CODE = '0041006400';

export const isExadisOrderItem = (orderItem: AftersalesOrderItem): boolean => {
  return orderItem.purchaseOrder?.supplier === EXADIS_SUPPLIER_CODE;
};

export const normalizeOptionalString = (value: string | undefined): string | undefined => {
  if (value === undefined) {
    return undefined;
  }

  const normalizedValue = value.trim();
  return normalizedValue === '' ? undefined : normalizedValue;
};
